import "./SkeletonStyle.css";

const RequestDetailsSkeleton = () => {
  return (
    <div className="request-details-skeleton">
      {/* Back Link */}
      <div className="skeleton-back-link skeleton-block" />

      {/* Header */}
      <div className="skeleton-header-section">
        <div className="skeleton-block skeleton-request-number" />
        <div className="skeleton-block skeleton-request-date" />
      </div>

      {/* Stepper Card */}
      <div className="skeleton-stepper-card">
        <div className="skeleton-stepper-flow">
          <div className="skeleton-stepper-item">
            <div className="skeleton-block skeleton-stepper-dot" />
            <div className="skeleton-block skeleton-stepper-label" />
          </div>
          <div className="skeleton-stepper-item">
            <div className="skeleton-block skeleton-stepper-dot" />
            <div className="skeleton-block skeleton-stepper-label" />
          </div>
          <div className="skeleton-stepper-item">
            <div className="skeleton-block skeleton-stepper-dot" />
            <div className="skeleton-block skeleton-stepper-label" />
          </div>
          <div className="skeleton-stepper-item">
            <div className="skeleton-block skeleton-stepper-dot" />
            <div className="skeleton-block skeleton-stepper-label" />
          </div>
        </div>
      </div>

      {/* Info Bar */}
      <div className="skeleton-info-bar">
        <div className="skeleton-block skeleton-info-item" />
        <div className="skeleton-block skeleton-info-item" />
        <div className="skeleton-block skeleton-info-item" />
        <div className="skeleton-block skeleton-info-item" />
      </div>

      {/* Tab */}
      <div className="skeleton-tabs">
        <div className="skeleton-block skeleton-tab" />
      </div>

      {/* Table */}
      <div className="skeleton-table-wrapper">
        <div className="skeleton-table">
          {/* Table Header */}
          <div className="skeleton-table-header">
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
            <div className="skeleton-block skeleton-th" />
          </div>

          {/* Table Rows */}
          <div className="skeleton-table-row">
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
          </div>
          <div className="skeleton-table-row">
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
          </div>
          <div className="skeleton-table-row">
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
            <div className="skeleton-block skeleton-td" />
          </div>
        </div>
      </div>

      {/* Action Button */}
      <div className="skeleton-actions">
        <div className="skeleton-block skeleton-proceed-btn" />
      </div>
    </div>
  );
};

export default RequestDetailsSkeleton;

